<template lang="pug">
  DataImportBase(
    :title="'使用者'"
    :uploadUrl="'/upload-user-table/'"
    :downloadUrl="'/export-user-table/'"
  )
</template>

<script>
import DataImportBase from './DataImportBase';

export default {
  name: 'UserImport',
  components: {
    DataImportBase,
  },
};
</script>


// WEBPACK FOOTER //
// UserImport.vue?28790e06